// Round 45-B, package PK — accounts: advanced account settings, pill and limits line in the Accounts step (C0, KONTRAKTY 2026-09-24).
// Subtree `appCampaigns.k45.*`: only this package edits this file; PL and EN keys together.
export const appCampaignsK45 = {
  k45: {
    // Accounts step: one action next to the „no publishing settings” pill (opens the account sheet in Accounts).
    set: 'Set',
    setLabel: 'Set publishing: {handle}',
    // One week grid (rule 62, MAPA B): the account's own schedule and the plan's „Weekly” mode.
    week: {
      days: 'Mon,Tue,Wed,Thu,Fri,Sat,Sun',
      free: 'free',
      perWeek: '{n} / wk',
      add: 'Add a time: {day}',
      edit: 'Change time {time}: {day}',
      remove: 'Remove time {time}: {day}',
    },
  },
}
